import axios from 'axios';
import { AppSettings } from '../models';

export class ConfigurationHelper {
  static loadConfiguration(): Promise<AppSettings> {
    return new Promise((resolve, reject) => {
      let configPath = '';
      if (process.env.NODE_ENV === 'production') {
        configPath = `${window.location.origin}/config.json`;
      } else {
        configPath = `${window.location.origin}/config.local.json`;
      }
      try {
        axios.get(configPath)
        .then((response: any) => {
          const appSettings: AppSettings = Object.assign(new AppSettings(), response.data);
          return resolve(appSettings);
        });
      } catch (error) {
        // tslint:disable-next-line:no-console
        console.error(`error loading app config - ${error}`);
        return reject('Unable to load app config');
      }
    });
  }

}
